import React, { useState, useEffect, useContext, Component } from "react";
import { ProductsContext } from "./products/productsContext";
import VariantSelector from "./VariantSelector";
import "./detailstyle.css";
import "./style.css";
import { Link } from "react-router-dom";
import Product from "./Product";
import Cart from "./Cart";
import Client from "shopify-buy";
import ReactHtmlParser from "react-html-parser";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Slider from "react-slick";


const client = Client.buildClient({
  domain: "conecuh-brands.myshopify.com",
  storefrontAccessToken: "fd73aae121a8110089143a1d450c7b6e",
});
const options = {
  items: 4,
  loop: true,
  margin: 10,
  nav: false,
  autoplay: true,
  autoplayHoverPause: true,
  autoplayTimeout: 3000,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 3,
    },
    1000: {
      items: 4,
    },
    1500: {
      items: 4,
    },
  },
};

const ProductDetailPage1 = (props) => {
  // eslint-disable-next-line
  const [products, setProducts] = useState();
  const data = useContext(ProductsContext);
  const [product, setProduct] = useState();
  const [showProduct, setShowProduct] = useState(false);
  const [currentProductIndex, setCurrentProductIndex] = useState(0);
  // eslint-disable-next-line
  const [selectedVariantImage, setSelectedVariantImage] = useState();

  const changeProduct = (product_id) => {
    
    let elementIndex = -1;
    let temp = null;
    if (props.match.params.category.toString() === "clyde-mays-shirts") {
      temp = data.shirts;
      setProducts(data.shirts);
    }
    if (props.match.params.category.toString() === "clyde-mays-hats") {
      temp = data.hats;
      setProducts(data.hats);
    }
    if (props.match.params.category.toString() === "clyde-mays-accessarries") {
      temp = data.accessarries;
      setProducts(data.accessarries);
    }

    temp.map((product) => {
      elementIndex += 1;
      if (product.id === product_id) {
        setCurrentProductIndex(elementIndex);
        setProduct(product);
        setShowProduct(true);
      }
      return null;
    });

  };

  const getParamsValue = (attribute) => {

    const urlSearch = window.location.search.replace("?", "");
    if (urlSearch.indexOf(attribute) === -1) {
      return null;
    }
    const splitArray = urlSearch.split(`${attribute}=`)

    let value = null;
    if (splitArray[1]) {
      value = splitArray[1].split('&')[0];
    }
    return value;
  }

  useEffect(() => {

    changeProduct(getParamsValue('id'));
  }, []);

  const nextProduct = () => {
    setShowProduct(false);
    setCurrentProductIndex(currentProductIndex + 1);
    setProduct(products[currentProductIndex + 1]);
    setShowProduct(true);
  };

  const prevProduct = () => {
    setShowProduct(false);
    setCurrentProductIndex(currentProductIndex - 1);
    setProduct(products[currentProductIndex - 1]);
    setShowProduct(true);
  };



  if (showProduct) {
    return (
      <div>
        <div>
          <ProductDetailPage
            totalProducts={products.length}
            client={client}
            nextProduct={nextProduct}
            prevProduct={prevProduct}
            currentProductIndex={currentProductIndex}
            product={product}
            selectedVariantImage={selectedVariantImage}
          />
        </div>

        <SliderClass
          category={props.match.params.category.toString()}
          client={client}
          products={products}
          changeProduct={changeProduct}
        />
      </div>
    );
  } else {
    return <div>LOADING.........</div>;
  }
};

class SliderClass extends Component {
  render() {
    let elementIndex = -1;
    let products = this.props.products.map((product) => {
      elementIndex += 1;
      return (
        <div key={product.id.toString()}>
          <Product
            Index={elementIndex}
            addVariantToCart={this.props.addVariantToCart}
            client={this.props.client}
            product={product}
            category={this.props.category}
            isproductForSlide={true}
            changeProduct={this.props.changeProduct}
            products={this.props.products}
          />
        </div>
      );
    });

    return (
      <div className="container-fluid owl_slider">
        <OwlCarousel className="owl-theme" {...options}>
          {products}
        </OwlCarousel>
      </div>
    );
  }
}

class ProductDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      setIsOpen: false,
      selectedVariantQuantity: 1,
    };
    let defaultOptionValues = {};
    this.props.product.options.forEach((selector) => {
      defaultOptionValues[selector.name] = selector.values[0].value;
    });
    this.state = { selectedOptions: defaultOptionValues };
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    let defaultOptionValues = {};
    if (prevProps !== this.props) {
      this.props.product.options.forEach((selector) => {
        defaultOptionValues[selector.name] = selector.values[0].value;
      });
      this.setState({
        selectedOptions: defaultOptionValues,
        selectedVariant: null,
        selectedVariantImage: null,
        selectedValue: this.props.product.options[0].values[0].value,
      });
    }
  }

  handleOptionChange(event, fieldName) {
    let selectedOptions = this.state.selectedOptions;
    selectedOptions[fieldName] = `${event.value}`;
    const selectedVariant = this.props.client.product.helpers.variantForOptions(
      this.props.product,
      selectedOptions
    );

    if (fieldName === "Color") {
      this.setState({
        selectedVariant: selectedVariant,
        selectedColorValue: `${event.value}`,
      });
    } else if (fieldName === "Size") {
      this.setState({
        selectedVariant: selectedVariant,
        selectedSizeValue: `${event.value}`,
      });
    } else {
      this.setState({
        selectedVariant: selectedVariant,
        selectedColorValue: `${event.value}`,
      });
    }

    if (this.props.product.images.length > 0) {
      var index = this.props.product.images
        .map(function (e) {
          return e.id;
        })
        .indexOf(selectedVariant.image.attrs.id.value);

      this.slider.slickGoTo(index);
    }
  }

  handleQuantityChange(event) {
    this.setState({
      selectedVariantQuantity: event.target.value,
    });
  };

  render() {

    let selectedOptions = this.state.selectedOptions;
    // selectedOptions["Color"] = this.props.product.options[0].values[0].value;
    const iniialSelectedVariant = this.props.client.product.helpers.variantForOptions(
      this.props.product,
      selectedOptions
    );
    var index = 0;
    if (this.props.product.images.length > 0 && iniialSelectedVariant !== undefined) {
      var index = this.props.product.images
        .map(function (e) {
          return e.id;
        }).indexOf(iniialSelectedVariant.image.attrs.id.value);
    }

    const settings = {
      customPaging: function (i) {
        return (
          <a>
            <img src={variantImage[i].src} />
          </a>
        );
      },
      dots: true,
      dotsClass: "slick-dots slick-thumb",
      infinite: false,
      initialSlide: index,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    let variantImage = this.props.product.images;
    let variant = this.state.selectedVariant || this.props.product.variants[0];
    let variantQuantity = this.state.selectedVariantQuantity || 1;
    let desc1 = this.props.product.descriptionHtml;
    let variantSelectors = this.props.product.options.map((option) => {
      return (
        <VariantSelector
          handleOptionChange={this.handleOptionChange}
          key={option.id.toString()}
          option={option}
          fieldName={option.name.toString()}
          selectedSizeValue={this.state.selectedSizeValue}
          selectedColorValue={this.state.selectedColorValue}
        />
      );
    });
    return (
      <div style={{ backgroundColor: "rgb(247, 240, 232)" }}>
        <div className="container-fluid p-0">
          <div
            className="card"
            style={{ border: "none", backgroundColor: "rgb(247, 240, 232)" }}>
            <div className="row">
              <div className="col-md-6 col-sm-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">  <Link to="/merch" style={{ color: "#95895f" }}>
                      <b>Home</b>
                    </Link></li>
                    <li className="breadcrumb-item active" aria-current="page"> {this.props.product.title}
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="col-md-6 col-sm-6">
                <nav aria-label="breadcrumb slide_right"
                >
                  <ol className="breadcrumb slide_right">
                    <li className="breadcrumb-item" style={{ color: "#95895f", cursor: "pointer" }}
                      onClick={
                        this.props.currentProductIndex > 0
                          ? this.props.prevProduct
                          : null
                      }> &lt; Previous</li>
                    <li className="breadcrumb-item active" aria-current="page" style={{ color: "#95895f", cursor: "pointer" }}
                      onClick={
                        this.props.currentProductIndex <
                          this.props.totalProducts - 1
                          ? this.props.nextProduct
                          : null
                      }>Next &gt;</li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="container-fliud p-4">
              <div className="wrapper row pt-4 mt-4">
                <div className="preview col-md-6">
                  <div className="preview-pic tab-content detal_page_product">
                    <Slider
                      ref={(slider) => (this.slider = slider)}
                      {...settings}
                    >
                      {variantImage.map((img, index) => (
                        <div key={index}>
                          <img src={img.src} />
                        </div>
                      ))}
                    </Slider>


                  </div>
                </div>
                <div className="details col-md-6">
                  <div id="myPortal" />

                  <h3 className="product-title">{this.props.product.title}</h3>
                  <h4 className="price">
                    <span style={{ color: "#95895f" }}>$   {variant.price.amount}</span>
                  </h4>

                  {variantSelectors}

                  <div
                    style={{
                      float: "left",
                      marginTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    <label className="quality_no">Quantity</label>
                    <input
                      min="1"
                      className="Product_quantity_option mobile-view"
                      type="number"
                      defaultValue={variantQuantity}
                      onChange={this.handleQuantityChange}
                    ></input>
                  </div>

                  <div className="action">
                    <Cart
                      variant_id={variant.id}
                      variantQuantity={variantQuantity}
                      isDetailPage={true}
                    />
                  </div>

                  <div className="product-description">
                    {ReactHtmlParser(desc1)}
                  </div>

                  <div className="social-icons">
                    <a
                      href="https://www.facebook.com/clydemays.whiskey.9"
                      target="_balnk"
                      style={{ marginLeft: "0px !important" }}
                    >
                      <span>
                        {/* <img
                          src={require("./images/facebook.svg")}
                          alt=""
                        ></img> */}
                        <i className="fa fa-facebook-f"></i>
                        <span className="icon-items">
                          FACEBOOK</span>


                      </span>
                    </a>
                    <a
                      href="https://www.linkedin.com/mwlite/company/conecuh-brands"
                      target="_balnk"
                    >
                      <span>
                        {/* <img
                          src={require("./images/linkedin.svg")}
                          alt=""
                        ></img> */}
                        <i className="fa fa-linkedin" aria-hidden="true"></i>


                        <span className="icon-items">
                          LINKEDIN</span>

                      </span>
                    </a>
                    <a
                      href="https://www.pinterest.com/clyde3787/"
                      target="_balnk"
                    >
                      <span>
                        {/* <img
                          src={require("./images/pinterest.svg")}
                          alt=""
                        ></img> */}
                        <i className="fa fa-pinterest" aria-hidden="true"></i>
                        <span className="icon-items">
                          PINTEREST</span>


                      </span>
                    </a>
                    <a
                      href="https://www.instagram.com/clydemayswhiskey/"
                      target="_balnk"
                    >
                      <span>
                        {/* <img
                          src={require("./images/instagram.png")}
                          alt=""
                        ></img> */}
                        <i className="fa fa-instagram" aria-hidden="true"></i>
                        <span className="icon-items">
                          Instagram</span>

                      </span>
                    </a>
                    <a
                      href="https://mobile.twitter.com/clydemays_?lang=en"
                      target="_balnk"
                    >
                      <span>
                        {/* <img
                          src={require("./images/twitter.svg")}
                          alt=""
                        ></img> */}

                        <i className="fa fa-twitter" aria-hidden="true"></i>
                        <span className="icon-items">
                          TWITTER
                        </span>

                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductDetailPage1;


// WEBPACK FOOTER //
// ./src/components/ProductDetailPage.js